import React from 'react';
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import DateAndTime from "../DateAndTime";
import "./styles.scss";

interface TopicDescriptionProps{
  index:number,
  description:string
  topic:string
  date?:string
  time?:string
}
const TopicsDescription:React.FC<TopicDescriptionProps> = ({index,description,topic,date,time}) => {
  const {t} = useTranslation();
  return (
      <div className='pack_info_area'>
        <h5 className='pack_topic'>
          <span className='lesson_no'>{t("common.Lesson")} {index+1}</span>
          {topic}
        </h5>
        {
          (date && time) &&
          <DateAndTime time={time} date={date}/>
        }
        <span className='lesson_description'>{description}</span>
      </div>
  );
};

export default TopicsDescription;